import Link from "next/link";
import { useState } from "react";
import { MdArrowForward } from "react-icons/md";
import Avatar from "../../../Atoms/Avatar";
import Rating from "../../../Atoms/Rating";
import TruncatedText from "../../../Atoms/TruncatedText";
import styles from "./Review.module.css";

const MAX_CHARACTERS = 250;

interface Props {
  id?: string;
  stars: number;
  text: string;
  date: string;
  userName: string;
  profileImageUrl: string | null;
  product?: any;
  booking?: {
    group: {
      guides: {
        nickName: string;
        profilePic: string;
      }[];
    };
  };
}

export default function Review({
  id,
  text,
  stars,
  date,
  userName,
  profileImageUrl,
  product,
  booking,
}: Props) {
  const [state, setState] = useState({
    full: false,
  });

  function renderFullReview() {
    return <span itemProp="reviewBody">{text}</span>;
  }

  function renderPartialReview() {
    return (
      <span itemProp="reviewBody">
        <TruncatedText text={text} maxLength={MAX_CHARACTERS} />{" "}
        <button
          className={styles.ReviewReadMore}
          onClick={() => setState({ full: true })}
        >
          Read more
        </button>
      </span>
    );
  }

  return (
    <div
      className={styles.Review}
      itemProp="review"
      itemScope
      itemType="http://schema.org/Review"
    >
      {booking && (
        <div>
          {booking.group.guides[0] && (
            <div className={styles.ReviewGuidedBy}>
              <Avatar
                size={48}
                name={booking.group.guides[0].nickName}
                src={booking.group.guides[0].profilePic}
              />
              <span>
                Guided by <b>{booking.group.guides[0].nickName}</b>
              </span>
            </div>
          )}
        </div>
      )}

      {product && product.translation && (
        <div
          itemProp="itemReviewed"
          itemScope
          itemType="http://schema.org/Product"
        >
          <Link
            href={`/product/${product.id}?ref=city_reviews&review_id=${id}`}
            className={styles.ReviewCardLink}
          >
            <span itemProp="name" className={styles.ReviewCardLinkText}>
              {product?.translation?.name}
            </span>
            <span className={styles.ReviewCardLinkIcon}>
              <MdArrowForward size={16} color="#f33f3a" />
            </span>
          </Link>
          <div
            itemProp="aggregateRating"
            itemScope
            itemType="http://schema.org/AggregateRating"
          >
            <meta itemProp="ratingValue" content="4.8" />
            <meta itemProp="reviewCount" content="5" />
          </div>
        </div>
      )}

      {product && product.translation ? null : (
        <div className={styles.ReviewReviewer}>
          <div className={styles.ReviewReviewerProfilePic}>
            <Avatar size={48} name={userName} src={profileImageUrl} />
          </div>
          <span itemProp="author">{userName}</span>
        </div>
      )}

      <div className={styles.ReviewContent}>
        <div className={styles.ReviewRating}>
          <span className={styles.ReviewRatingStars}>
            <Rating value={Math.round(stars)} size={"small"} />
          </span>{" "}
          <span
            style={{
              position: "relative",
              top: 2,
            }}
          >
            {product && product.translation && (
              <span itemProp="author">reviewed by: {userName} </span>
            )}
          </span>
        </div>

        <p className={styles.ReviewBody}>
          {state.full || text.length <= MAX_CHARACTERS
            ? renderFullReview()
            : renderPartialReview()}
        </p>
      </div>
    </div>
  );
}
